import { getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { collection, getFirestore } from "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyCPiqGiVQFutBdnSZDcWvx4UwngCq96iaI",
  authDomain: "zoom-clone-077.firebaseapp.com",
  projectId: "zoom-clone-077",
  storageBucket: "zoom-clone-077.appspot.com",
  messagingSenderId: "920466795539",
  appId: "1:920466795539:web:eb2d5413c339b77151e3e6",
  measurementId: "G-FG9GKRDLYY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const firebaseAuth = getAuth(app);
export const firebaseDB = getFirestore(app);

export const usersRef = collection(firebaseDB, "users");
export const meetingsRef = collection(firebaseDB, "meetings");
